import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";
import { OfficialsService } from "src/app/services/officials.service";
// import { PaymentSettlementService } from "src/app/services/payment-settlement.service";

@Component({
  selector: "app-secure-payment-extension-list",
  templateUrl: "./payment-extension-list.component.html",
  styleUrls: ["./payment-extension-list.component.scss"],
})
export class PaymentExtensionListComponent implements OnInit {
  lotteryList: { [key: number]: string };
  loaded: boolean = false;
  
  selectedLotteryCode: string | null = null;

  
  page: Page<PaymentSettlementModel>;
  dataSource: MatTableDataSource<PaymentSettlementModel> = new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    // "transactionId",
    "applicantName",
    "schemaCode",
    "applicantStatus",

    // "transactionDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private _snackBar: MatSnackBar,

    private route: ActivatedRoute,

    // private paymentSettlementService: PaymentSettlementService,
    private officialsService : OfficialsService
  ) {}

  ngOnInit(): void {
    this.loaded = true;
    this.route.params.subscribe((params: Params) => {
      this.officialsService.initPagePayment().subscribe(
        (data: any) => {
          this.loaded = false;

          if (data.status === "SUCCESS") {
            this.lotteryList = data.lotteryList;
            console.log("data.lotteryName", this.lotteryList);
          } else {
            this.officialsService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.officialsService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
    });

    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-payment-settlement-filterText"),
        [Validators.required, Validators.minLength(3)]
      ),
      lotterysName: new FormControl(null, [Validators.required]),
    });
    this.filterForm.controls["filterText"].setValue(null);
  }
  
  onLotteryChange(value: any) {
    this.lotteryEventId = value.key;

    // console.log(" this.lotteryEventId:", this.lotteryEventId);
    // this.loadData();
  }
  loadData() {
    this.loaded = true;
    if (this.lotteryEventId !== null) {
      this.officialsService
        .getPaymentExtensionList(
          this.lotteryEventId,
          this.currentPage,
          this.pageSize,
          this.filterForm.value.filterText
        )
        .subscribe(
          (page: any) => {
            this.loaded = false;
            this.page = page.page;
            console.log('Page content ',this.page);

            this.dataSource = new MatTableDataSource(this.page.content);

            // this.dataSource = this.page.content;
            // if (
            //   page.content.applicationNo !== null &&
            //   page.content.applicationNo !== ""
            // ) {
            // if (page.content[0] !== null) {
              // this.dataSource = new MatTableDataSource(page.content);
            // } else {
            //   this.dataSource = new MatTableDataSource<PaymentSettlementModel>(
            //     []
            //   );
            // }
            console.log("this.dataSource ", this.dataSource);
            // } else {
            //   this.loaded = false;
            //   this.officialsService.errorToast(page.errorMessage);
            // }
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = this.page.totalElements;
            });
            this.isSearchDisabled = false;
          },
          (error) => {
            this.loaded = false;
            console.log(error);
            this.isSearchDisabled = false;
          }
        );
    } else {
      this.officialsService.errorToast("Please select Lottery");
      this.loaded = false;
    }
  }

  // onStatusChange(value: any) {
  //   this.statusId = value;
  //   this.loaded = false;
  //   this.loadData();
  // }

  resetFilter() {
    window.location.reload();
    this.filterForm.controls["filterText"].setValue(null);
    // this.filterForm.controls["status"].setValue(null);
    // this.filterForm.controls["lotterysName"].setValue(null);

    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }
  onSearch() {

    if (this.filterForm.value.filterText) {
      this.page = null;
      this.dataSource = null;
      this.pageSize = 0;
      this.currentPage = 0;
      localStorage.setItem(
        "app-secure-payment-settlement-filterText",
        this.filterForm.value.filterText
      );

      this.onLoad();
    } else {
      this._snackBar.open(
        "Lottery Name and Application Number is Required ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = true;
    console.log(
      "this.filterForm.value.filterText",
      this.filterForm.value.filterText
    );
    this.officialsService
      .getPaymentExtensionList(
        this.lotteryEventId,
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data: any) => {
          this.page = data.page;
          console.log(this.page);
          this.loaded = false;
          if (this.page.content && this.page.content.length > 0) {
            console.log('page.content list ',this.page.content );
            this.dataSource = new MatTableDataSource(this.page.content);
          } else {
            this._snackBar.open(
              "Please Enter Valid Application Number ",
              "Close",
              {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
              }
            );
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = this.page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = false;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
  }

  // ngAfterViewInit(): void {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }

  pageChanged(event: PageEvent) {
    console.log({ event });
    console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}
